import * as React from 'react';
import * as styles from './styles.css';

import { FormFieldInput, IconSearch16, Responsive } from '@cian/ui-kit';
import { AddFull16 } from '@cian/ui-kit/prev';

export interface ISearchTextInputProps {
  width?: number | string;
  value: string;
  onChange(value: string): void;
  onFocus?: React.FocusEventHandler;
  onBlur?: React.FocusEventHandler;
  clearInput?(): void;
}

export const SearchTextInput = React.forwardRef<HTMLDivElement, ISearchTextInputProps>((props, ref) => {
  const { width = 368, value, onChange, clearInput, onFocus, onBlur } = props;
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value),
    [onChange],
  );

  return (
    <FormFieldInput
      data-testid="search_text_input"
      width={width}
      value={value}
      onChange={handleChange}
      placeholder="Имя, телефон или название агентства"
      leftAdornment={
        <div className={styles['loupe']}>
          <IconSearch16 color="superblack_60" />
        </div>
      }
      rightAdornment={
        value && (
          <Responsive tablet phone>
            <div className={styles['clear']} onClick={clearInput}>
              <div className={styles['clear-icon']}>
                <AddFull16 color="superblack_40" />
              </div>
            </div>
          </Responsive>
        )
      }
      ref={ref}
      onFocus={onFocus}
      onBlur={onBlur}
      autoComplete="off"
    />
  );
});

SearchTextInput.displayName = 'SearchTextInput';
